import CRUDActions from './CRUD';
import Player from '../api/player';

class PlayerCRUDActions extends CRUDActions {
  prefix = 'player';

  get _model() {
    return Player;
  }

  loadLazyItems() {
    return this.fetchList();
  }
}


export default new PlayerCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/player.js